"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var hooks_1 = require("../../../utils/hooks");
var util_1 = require("../../../utils/util");
var types_1 = require("../types");
function mapEventTargetValue(changeEvent) {
    return changeEvent.target.value;
}
exports.mapEventTargetValue = mapEventTargetValue;
function default_1(props) {
    var disabled = props.disabled, valueProp = props.value, fieldNameProp = props.fieldName, onBlurProp = props.onBlur, defaultValue = props.defaultValue, onChange = props.onChange, mapFormValue = props.mapFormValue, children = props.children;
    var form = React.useContext(types_1.FormContext).form;
    var _a = React.useContext(types_1.FieldContext), hintId = _a.hintId, errorId = _a.errorId, label = _a.label, contextFieldName = _a.fieldName, contextFieldId = _a.fieldId;
    var isMounted = React.useRef(false);
    var _b = __read(React.useState(defaultValue), 2), stateValue = _b[0], setStateValue = _b[1];
    var fieldName = fieldNameProp || contextFieldName;
    var fieldId = React.useMemo(function () {
        return (contextFieldId ||
            (fieldName && fieldName.replace(/\W/g, "_") + "-" + util_1.uniqueGUID()));
    }, [contextFieldId, fieldName]);
    // simply having a form context and field name is enough to flush things to a form
    var useForm = !!(form && fieldName);
    // only use state if we aren't in a form, and the component is uncontrolled
    var useState = !useForm && valueProp === undefined;
    // Flush defaultValue prop to state or form
    React.useEffect(function () {
        isMounted.current = true;
        if (defaultValue !== undefined
            && valueProp === undefined
            && useForm) {
            form.setValue(fieldName, defaultValue, true);
        }
    }, []); // only run on mount
    // Flush value props to context
    var prevValue = hooks_1.usePrevious(valueProp);
    React.useEffect(function () {
        if (useForm && (prevValue !== undefined || valueProp !== undefined)) {
            // only flush if the value changed, or the value doesn't match the form value
            var valueDelta = JSON.stringify(prevValue) !== JSON.stringify(valueProp);
            var formDelta = JSON.stringify(valueProp) !== JSON.stringify(form.getValue(fieldName));
            if (valueDelta || formDelta) {
                // don't touch if we're 'mounting'
                var noTouch = prevValue === undefined && form.getValue(fieldName) === undefined;
                form.setValue(fieldName, valueProp, noTouch);
            }
        }
    }, [valueProp, useForm && form.getValue(fieldName)]);
    // value prop > form context value > state value
    var value = valueProp;
    if (value === undefined && useForm) {
        value = form.getValue(fieldName);
    }
    else if (useState) {
        value = stateValue;
    }
    if (value === undefined
        && defaultValue !== undefined
        && isMounted.current === false) {
        value = defaultValue;
    }
    return (React.createElement(React.Fragment, null, children({
        value: value,
        hintId: hintId,
        errorId: errorId,
        fieldId: fieldId,
        fieldName: fieldName,
        label: label,
        onChange: function (oc) {
            if (disabled) {
                return;
            }
            var mappedValue = mapFormValue ? mapFormValue(oc) : oc;
            if (useForm) {
                form.setValue(fieldName, mappedValue);
            }
            if (useState) {
                setStateValue(mappedValue);
            }
            if (onChange) {
                onChange(oc);
            }
        },
        onBlur: function (ob) {
            if (useForm) {
                form.setTouched(fieldName);
            }
            if (onBlurProp) {
                onBlurProp(ob);
            }
        }
    })));
}
exports.default = default_1;
//# sourceMappingURL=InputHelper.js.map